var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_13941)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1155_13941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8418 4.91797H48.9604C47.9437 2.05327 45.2065 -0.00390625 41.998 -0.00390625C38.7896 -0.00390625 36.0524 2.05327 35.0357 4.91797H32.1543C28.0833 4.91797 24.7715 8.22973 24.7715 12.3008C24.7715 13.661 25.8722 14.7617 27.2324 14.7617H56.7637C58.1239 14.7617 59.2246 13.661 59.2246 12.3008C59.2246 8.22973 55.9128 4.91797 51.8418 4.91797Z",
    fill: "url(#paint0_linear_1155_13941)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1155_13941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6074 9.83984H63.8974C64.0597 10.6354 64.1465 11.4582 64.1465 12.3008C64.1465 16.3718 60.8347 19.6836 56.7637 19.6836H27.2324C23.1614 19.6836 19.8496 16.3718 19.8496 12.3008C19.8496 11.4582 19.9364 10.6354 20.0987 9.83984H17.3887C13.3176 9.83984 10.0059 13.1516 10.0059 17.2227V76.6133C10.0059 80.6843 13.3176 83.9961 17.3887 83.9961H66.6074C70.6785 83.9961 73.9902 80.6843 73.9902 76.6133V17.2227C73.9902 13.1516 70.6785 9.83984 66.6074 9.83984ZM34.6152 68.9023H24.7715C23.4112 68.9023 22.3105 67.8016 22.3105 66.4414C22.3105 65.0812 23.4112 63.9805 24.7715 63.9805H34.6152C35.9755 63.9805 37.0762 65.0812 37.0762 66.4414C37.0762 67.8016 35.9755 68.9023 34.6152 68.9023ZM34.6152 51.6758H24.7715C23.4112 51.6758 22.3105 50.5751 22.3105 49.2148C22.3105 47.8546 23.4112 46.7539 24.7715 46.7539H34.6152C35.9755 46.7539 37.0762 47.8546 37.0762 49.2148C37.0762 50.5751 35.9755 51.6758 34.6152 51.6758ZM34.6152 34.4492H24.7715C23.4112 34.4492 22.3105 33.3485 22.3105 31.9883C22.3105 30.628 23.4112 29.5273 24.7715 29.5273H34.6152C35.9755 29.5273 37.0762 30.628 37.0762 31.9883C37.0762 33.3485 35.9755 34.4492 34.6152 34.4492ZM58.5036 69.6234C59.4648 70.5846 59.4648 72.1421 58.5036 73.1033C58.0228 73.584 57.3932 73.8244 56.7637 73.8244C56.1342 73.8244 55.5043 73.584 55.0238 73.1033L51.8418 69.9213L48.6598 73.1033C48.1791 73.584 47.5494 73.8244 46.9199 73.8244C46.2904 73.8244 45.6606 73.584 45.18 73.1033C44.2188 72.1421 44.2188 70.5846 45.18 69.6234L48.3619 66.4414L45.1799 63.2594C44.2186 62.2982 44.2186 60.7407 45.1799 59.7795C46.1411 58.8182 47.6986 58.8182 48.6598 59.7795L51.8418 62.9615L55.0238 59.7795C55.985 58.8182 57.5425 58.8182 58.5037 59.7795C59.465 60.7407 59.465 62.2982 58.5037 63.2594L55.3217 66.4414L58.5036 69.6234ZM60.9645 46.0329L53.5817 53.4157C53.101 53.8964 52.4713 54.1367 51.8418 54.1367C51.2123 54.1367 50.5824 53.8964 50.1019 53.4157L45.18 48.4938C44.2188 47.5325 44.2188 45.9751 45.18 45.0139C46.1413 44.0526 47.6987 44.0526 48.66 45.0139L51.8418 48.1959L57.4847 42.5529C58.446 41.5917 60.0034 41.5917 60.9646 42.5529C61.9259 43.5142 61.9259 45.0716 60.9645 46.0329ZM60.9645 31.2672L53.5817 38.65C53.101 39.1307 52.4713 39.3711 51.8418 39.3711C51.2123 39.3711 50.5824 39.1307 50.1019 38.65L45.18 33.7282C44.2188 32.7669 44.2188 31.2095 45.18 30.2482C46.1413 29.287 47.6987 29.287 48.66 30.2482L51.8418 33.4302L57.4847 27.7873C58.446 26.8261 60.0034 26.8261 60.9646 27.7873C61.9259 28.7485 61.9259 30.306 60.9645 31.2672Z",
    fill: "url(#paint1_linear_1155_13941)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1155_13941",
    x: 22.1508,
    y: -0.00390625,
    width: 39.6945,
    height: 20.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.62069
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.221436 0 0 0 0 0.221436 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1155_13941"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1155_13941",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1155_13941",
    x: 7.38517,
    y: 9.83984,
    width: 69.2258,
    height: 79.3976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.62069
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.221436 0 0 0 0 0.221436 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1155_13941"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1155_13941",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1155_13941",
    x1: 41.998,
    y1: -0.00390625,
    x2: 41.998,
    y2: 14.7617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1155_13941",
    x1: 41.998,
    y1: 9.83984,
    x2: 41.998,
    y2: 83.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_13941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.82459364bbcf5edcfcae5a2383514dd2.svg";
export { ForwardRef as ReactComponent };